// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".profile-container {\n  text-align: left;\n  font-family: 'Helvetica Neue';\n}\n.profile-container .user-avatar {\n  height: 64px;\n  width: 64px;\n  border-radius: 7px;\n  margin: 0px;\n  object-fit: cover;\n  display: inline-block;\n}\n", ""]);
// Exports
module.exports = exports;
